import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import data1 from "../../Data/dissertationData1.json";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

export default function Dissertation() {
  useSEO(seoConfig.dissertation);

  return (
    <section className="contacts dissertation">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title dissertation__title">
        Диссертационный совет
      </h1>

      <div className="dissertation__buttons">
        <h4 className="dissertation__button">
          <a
            href="/science/dissertation/videobroadcast"
            className="prevention__link employees__link dissertation__link"
          >
            Видеотрансляции
          </a>
        </h4>

        <h4 className="dissertation__button">
          <a
            href="/science/dissertation/advertisements"
            className="prevention__link employees__link dissertation__link"
          >
            Объявления о защите кандидатских и докторских диссертаций
          </a>
        </h4>
      </div>

      {/* <h4 className="dissertation__caption">
        Диссертация Рустамхановой Г.Р. снята с рассмотрения по личному заявлению
        соискателя от 24.11.2025 г.
      </h4> */}

      {/* <p className="dissertation__text">
        <strong>26.11.2025г. в 11:00</strong> состоится заседание
        Диссертационного совета 72.1.018.01, посвященное защите диссертации на
        соискание ученой степени кандидата медицинских наук "Совершенствование
        комплексной терапии больных онихомикозом и микозом стоп с учетом
        показателей метаболической активности микрофлоры кишечника"
        Рустамхановой Гульназ Радиковны.
      </p>
      <h4 className="dissertation__caption">
        Место проведения заседания Диссертационного совета 72.1.018.01:
      </h4>
      <p className="dissertation__text">
        Государственное бюджетное учреждение Свердловской области "Уральский
        научно-исследовательский институт дерматовенерологии и иммунопатологии",
        г. Екатеринбург, ул. Щербакова, д. 8.
      </p> */}

      <p className="dissertation__text">
        <strong>13.03.2026 в 11.00</strong> состоялось заседание
        Диссертационного совета 72.1.018.01, по защите диссертации на соискание
        ученой кандидата медицинских наук "Совершенствование комплексной терапии
        больных онихомикозом и микозом стоп с учетом показателей метаболической
        активности микрофлоры кишечника" Рустамхановой Гульназ Радиковны.
      </p>

      <p className="dissertation__text">
        <strong>27.12.2024 в 11.00</strong> состоялось заседание
        Диссертационного совета 72.1.018.01, по защите диссертации на соискание
        ученой степени доктора медицинских наук "Сифилитическая инфекция:
        клинико-патогенетические подходы к совершенствованию диагностики и
        контроля эффективности терапии" Левчик Надежды Константиновны и защите
        диссертации на соискание ученой степени кандидата медицинских наук
        "Реабилитационная тактика ведения больных акне в межрецидивный период"
        Полищука Антона Ильича.
      </p>

      <h4 className="dissertation__caption">
        Место проведения заседания Диссертационного совета 72.1.018.01:
      </h4>
      <p className="dissertation__text">
        Государственное бюджетное учреждение Свердловской области «Уральский
        научно-исследовательский институт дерматовенерологии и иммунопатологии»,
        г. Екатеринбург, ул. Щербакова, д. 8.
      </p>

      <h4 className="dissertation__caption">23 августа 2024 г.</h4>
      <p className="dissertation__text">
        На заседании Диссертационного совета 72.1.018.01 от 23.08.2024 г.
        (протокол № 68) открытым голосованием члены совета проголосовали против
        лишения Тамразовой Ольги Борисовны ученой степени доктора медицинских
        наук.
      </p>

      <h4 className="dissertation__caption">Объявление</h4>
      <p className="dissertation__text">
        В соответствии с п. 69 Положения о совете по защите диссертаций на
        соискание ученой степени кандидата наук, на соискание ученой степени
        доктора наук, утвержденного приказом Министерства образования и науки
        Российской Федерации от 10.11.2017 г. № 1093, извещаем о проведении
        заседания Диссертационного совета 72.1.018.01 по рассмотрению заявления
        о лишении <strong>Тамразовой Ольги Борисовны</strong> ученой степени
        доктора медицинских наук.
      </p>

      <h4 className="dissertation__caption">
        Место проведения заседания Диссертационного совета 72.1.018.01:
      </h4>
      <p className="dissertation__text">
        Государственное бюджетное учреждение Свердловской области «Уральский
        научно-исследовательский институт дерматовенерологии и иммунопатологии»,
        г. Екатеринбург, ул. Щербакова, д. 8.
      </p>
      <p className="dissertation__text">
        Заседание Диссертационного совета 72.1.018.01 состоится: 23 августа 2024
        г. в 11:00
      </p>

      <h4 className="dissertation__caption">16 октября 2023 г.</h4>
      <p className="dissertation__text">
        На заседании Диссертационного совета 72.1.018.01 от 13.10.2023 г.
        (протокол № 66) открытым голосованием члены совета проголосовали против
        лишения Мазур Минары Абдусаламовны ученой степени кандидата медицинских
        наук.
      </p>

      <h4 className="dissertation__caption">13 октября 2023 г. в 10.00</h4>
      <p className="dissertation__text">
        Состоялось заседание Диссертационного совета 72.1.018.01 по рассмотрению
        заявления о лишении Мазур Минары Абдусаламовны ученой степени кандидата
        медицинских наук.
      </p>

      <p className="dissertation__text">
        Место проведения заседания Диссертационного совета 72.1.018.01:
        государственное бюджетное учреждение Свердловской области «Уральский
        научно-исследовательский институт дерматовенерологии и
        иммунопатологии»», г. Екатеринбург, ул. Щербакова, д. 8.
      </p>

      <div>
        <h3 className="about-nii__title antiCorruption__title">Приказы</h3>

        <Accordion data={data1} />
      </div>

      <h4 className="dissertation__caption"> </h4>
      <p className="dissertation__text">
        В соответствии с приказами Рособрнадзора и Минобрнауки России (№ 1387-
        444 от 04.06.10 г., 192/нк от 09.04.2013 г., 339/нк от 18.06.2014 г.,
        587/нк от 25.06.2016 и 755/нк от 12.07.2017, 344/нк от 18.12.2018, от
        03.06.2021 г. № 561/нк, от 25.11.2025 г. № 1131/нк), состав действующего
        Диссертационного совета 72.1.018.01 (Д 208.129.01) по защите
        кандидатских и докторских диссертаций утвержден в количестве 17 человек.
        <br></br>
        <br></br>
        Председатель Диссертационного совета - директор ГБУ СО «УрНИИДВиИ»,
        доктор медицинских наук, профессор Николай Васильевич Кунгуров, зам.
        председателя - доктор медицинских наук, профессор Наталья Владимировна
        Зильберберг. Ученый секретарь диссертационного совета – доктор
        медицинских наук, доцент Юлия Николаевна Грекова. Тел. (343) 218-89-54.
        <br></br>
        <br></br>В Диссертационном совете работают: 17 докторов медицинских
        наук, из них 8 - ведущие ученые из других крупных медицинских и
        образовательных учреждений. На заседаниях Диссертационного совета
        рассматриваются докторские и кандидатские диссертации по актуальным
        проблемам дерматовенерологии. Члены совета дают отзывы о
        научно-практической значимости диссертаций, направляемых советами других
        дерматовенерологических учреждений.
        <br></br>
        <br></br>Заявления от соискателей и ходатайства от учреждений, в которых
        выполнялись диссертационные работы, принимаются по адресу: 620076,
        Екатеринбург, ул. Щербакова, 8, каб. 104. Тел. (343) 218-33-71,
        218-95-70
      </p>
    </section>
  );
}
